module.exports = __webpack_public_path__ + "static/media/money-key-EN.f46b2006.png";